import { PropsWithChildren, useContext } from 'react';

import {
  LegendFilterProvider,
  createLegendFilterContext,
} from 'business/providers/legend-filters';

interface ActivityAnalyseLegendFilters extends Record<string, unknown> {
  allActivities: boolean;
  selectedActivities: string[];
}

const activityAnalyseDefaultLegendFilters: ActivityAnalyseLegendFilters = {
  allActivities: true,
  selectedActivities: [],
};

const ActivityAnalyseLegendFilterContext = createLegendFilterContext(
  activityAnalyseDefaultLegendFilters,
);

const ActivityAnalyseLegendFilterProvider = ({
  children,
}: PropsWithChildren) => {
  return (
    <LegendFilterProvider
      defaultLegendFilters={activityAnalyseDefaultLegendFilters}
      legendFilterContext={ActivityAnalyseLegendFilterContext}
    >
      {children}
    </LegendFilterProvider>
  );
};

const useActivityAnalyseLegendFilters = () =>
  useContext(ActivityAnalyseLegendFilterContext);

export {
  type ActivityAnalyseLegendFilters,
  ActivityAnalyseLegendFilterProvider,
  useActivityAnalyseLegendFilters,
};
